<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading"></loading>
        <div v-if="bool_isAMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow" style="max-width:600px;"
                         role="dialog"
                         aria-labelledby="modalTitle"
                         aria-describedby="modalDescription">
                        <CCard style="height:100%;">
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{ getLanguage["SACH"]["TC"] }}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right"
                                                 @click="closeAdd">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content" style="overflow:inherit;">
                                    <CRow v-if="getUserInfo.AT !== 4">
                                        <CCol col="12" class="form-group">
                                            <label class="col-form-label-sm">{{this.getLanguage["AG"]["G"]}}* :</label>
                                            <customtreeselect :multiple="false"
                                                              :options="dd_agentgroup2"
                                                              :defaultExpandLevel="Infinity"
                                                              :clearable="false"
                                                              :flat="true"
                                                              :placeholder="this.utilGetDDLanguage('AG.PG')"
                                                              v-model="obj_Balance.PGIT"
                                                              @input="ParentGroupChange" />
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="12" class="form-group">
                                            <label class="col-form-label-sm">{{this.getLanguage["AG"]["SUB"]}} :</label>
                                            <treeselect :multiple="false"
                                                        :async="true"
                                                        :cacheOptions="bool_cacheOptionValue"
                                                        :load-options="loadSubBrandOptions"
                                                        :defaultOptions="ddDefaultSubBrand"
                                                        :disable-branch-nodes="true"
                                                        :searchPromptText="this.getLanguage['GL']['DDTS']"
                                                        :placeholder="getLanguage['AG']['SUB']"
                                                        v-model="obj_Balance.AGIT"
                                                        @input="AgentGroupChange" />
                                            <span class="ErrMsg">{{ ValidationSystemBalanceErrMsg('obj_Balance.AGIT', 'SUB') }}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="12" class="form-group">
                                            <label class="col-form-label-sm">{{this.getLanguage["SACH"]["CB"]}}</label>
                                            <CInput :placeholder="getLanguage['SACH']['CB']"
                                                    size="sm"
                                                    :value="obj_Balance.CB" disabled></CInput>
                                        </CCol>
                                    </CRow>
                                    <CRow v-if="obj_Balance.BT!=99">
                                        <CCol col="12" class="form-group">
                                            <label class="col-form-label-sm full-width">
                                                {{getLanguage["AG"]["BTUA"]}} ({{ this.str_currencysymbol }})<span class="required" /> : <span class="amountNote" v-if="getThousandCurrency">{{getLanguage["GL"]["CUR"]}}</span>
                                                <span class="float-right label-tooltip" style="padding-right:1%;">{{ this.getLanguage['AG']['SBAB']}} : {{ this.AvailableBalanceAmount() }}</span>
                                            </label>
                                            <CInput :placeholder="getLanguage['AG']['BTUA']"
                                                    size="sm"
                                                    :value="ThousandSeparator(obj_Balance.BU, getThousandCurrency ? 3 : 2)"
                                                    @change="v => obj_Balance.BU = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)"></CInput>
                                            <span class="ErrMsg">{{ ValidationSystemBalanceErrMsg('obj_Balance.BU', 'BTUA') }}</span>
                                        </CCol>
                                    </CRow>
                                </div>
                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-info" size="sm" @click="updateBalance()">
                                        <span class='plusIcon cil-plus'></span>
                                        {{ getLanguage["AG"]["TUSB"] }}
                                    </CButton>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_isBT">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow" style="max-width:600px;"
                         role="dialog"
                         aria-labelledby="modalTitle"
                         aria-describedby="modalDescription2">
                        <CCard style="height:100%;">
                            <CCardBody class="modal-body" id="modalDescription2">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{ getLanguage["SACH"]["BUL"] }}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right"
                                                 @click="closeAdd1">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content" style="overflow:inherit;">
                                    <CRow v-if="getUserInfo.AT !== 4">
                                        <CCol col="12" class="form-group">
                                            <label class="col-form-label-sm">{{this.getLanguage["AG"]["G"]}}* :</label>
                                            <customtreeselect :multiple="false"
                                                              :options="dd_agentgroup2"
                                                              :defaultExpandLevel="Infinity"
                                                              :clearable="false"
                                                              :flat="true"
                                                              :placeholder="this.utilGetDDLanguage('AG.PG')"
                                                              v-model="obj_Bonus.PGIT"
                                                              @input="ParentGroupChange" />
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="12" class="form-group">
                                            <label class="col-form-label-sm">{{this.getLanguage["AG"]["SUB"]}} <span class="required" /> : </label>
                                            <treeselect :multiple="false"
                                                        :async="true"
                                                        :cacheOptions="bool_cacheOptionValue"
                                                        :load-options="loadSubBrandOptions"
                                                        :defaultOptions="ddDefaultSubBrand"
                                                        :disable-branch-nodes="true"
                                                        :searchPromptText="this.getLanguage['GL']['DDTS']"
                                                        :placeholder="getLanguage['AG']['SUB']"
                                                        v-model="obj_Bonus.AGIT"
                                                        @input="AgentGroupChange" />
                                            <span class="ErrMsg">{{ ValidationSystemBalanceErrMsg('obj_Bonus.AGIT', 'SUB') }}</span>
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="12" class="form-group">
                                            <label class="col-form-label-sm">{{this.getLanguage["PM"]["BU"]}}</label>
                                            <CInput :placeholder="getLanguage['PM']['BU']"
                                                    size="sm"
                                                    :value="obj_Bonus.BU" disabled></CInput>
                                        </CCol>
                                    </CRow>
                                    <CRow v-if="obj_Bonus.BT!=99">
                                        <CCol col="12" class="form-group">
                                            <label class="col-form-label-sm full-width">
                                                {{getLanguage["SACH"]["ADJ"]}} <span class="required" /> :
                                            </label>
                                            <div class="radio-container">
                                                <div v-for="(option, optionIndex) in ['DSB', 'AD']" :key="option.id" class="inline radio-container">
                                                    <input type="radio"
                                                           :value="optionIndex"
                                                           name="BonusType"
                                                           v-model="obj_Bonus.BONT" />
                                                    <span class="col-form-label-sm">{{option == 'DSB'? getLanguage["AG"][option]: getLanguage["BTN"][option]}}</span>
                                                </div>
                                            </div>
                                        </CCol>
                                    </CRow>
                                    <CRow v-if="obj_Bonus.BT!=99">
                                        <CCol col="12" class="form-group">
                                            <label class="col-form-label-sm full-width">
                                                {{getLanguage["SACH"]["AMT"]}} ({{ this.str_currencysymbol }})<span class="required" /> : <span class="amountNote" v-if="getThousandCurrency">{{getLanguage["GL"]["CUR"]}}</span>
                                                <span class="float-right label-tooltip" style="padding-right:1%;">{{ formatNumber(selectedMinBonus, str_decimalSeparator, str_thousandSeparator, 2, str_currencysymbol) }} - {{ formatNumber(selectedMaxBonus, str_decimalSeparator, str_thousandSeparator, 2, str_currencysymbol) }}</span>
                                            </label>
                                            <CInput :placeholder="getLanguage['PM']['PA']"
                                                    size="sm"
                                                    :value="ThousandSeparator(obj_Bonus.AA, getThousandCurrency ? 3 : 2)"
                                                    @change="v => obj_Bonus.AA = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)"></CInput>
                                            <span class="ErrMsg">{{ ValidationSystemBalanceErrMsg('obj_Bonus.AA', 'SACH.AMT') }}</span>
                                        </CCol>
                                    </CRow>
                                </div>
                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-info" size="sm" @click="updateBonus()">
                                        <span class='plusIcon cil-plus'></span>
                                        {{ getLanguage["AG"]["ADJ"] }}
                                    </CButton>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{this.getLanguage["SACH"]["CH"]}}</h2>
                        <CButton v-if="checkModuleAccess2(constAccessType.edit)" size="sm" color="outline-info" @click="adjustSystemBalance(1)"><span class='plusIcon cil-plus'></span>{{this.getLanguage["AG"]["TUSB"]}}</CButton>
                        <CButton size="sm" color="outline-info" @click="adjustSystemBonus(1)" v-if="bool_isOutlet && !isOUTMOB && checkModuleAccess2(constAccessType.edit)"><span class='plusIcon cil-plus'></span>{{this.getLanguage["SACH"]["BUL"]}}</CButton>

                        <div class="custom-tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div class='searchCol' v-if="getUserInfo.AT !== 4">
                                <span class='searchLabel80'>{{this.getLanguage["AG"]["PG"]}} :</span>
                                <customtreeselect :multiple="false"
                                                  :options="dd_agentgroup"
                                                  :flat="true"
                                                  :defaultExpandLevel="Infinity"
                                                  :placeholder="this.utilGetDDLanguage('AG.PG')"
                                                  :clearable="false"
                                                  v-model="arr_FV['AGI']"
                                                  @input="SearchParentGroupChange" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["GL"]["SAGT"]}} :</span>
                                <treeselect :multiple="false"
                                            :async="true"
                                            :cacheOptions="true"
                                            :load-options="loadSubBrandOptionsSearch"
                                            :defaultOptions="ddDefaultSubBrandSearch"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                            :placeholder="this.utilGetDDLanguage('GL.SAGT')"
                                            v-model="arr_FV['SAGAGI']"
                                            :key="subbrandkey"
                                            @input="SearchSubGroupChange" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["GL"]["SD"]}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="center"
                                                   :auto-apply="true"
                                                   v-model="arr_FV['DR']"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="arr_FV['DR'].startDate != ''">
                                            <CInput size="sm"
                                                    :value="arr_FV['DR'].startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["GL"]["ED"]}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="center"
                                                   :auto-apply="true"
                                                   v-model="arr_FV['DR']"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="arr_FV['DR'].endDate != ''">
                                            <CInput size="sm"
                                                    :value="arr_FV['DR'].endDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel80'>{{this.getLanguage["AG"]["BAT"]}} :</span>
                                <customtreeselect :multiple="false"
                                                  :options="dd_adjustmenttype"
                                                  :clearable="true"
                                                  :defaultExpandLevel="Infinity"
                                                  :placeholder="getLanguage['AG']['BAT']"
                                                  v-model="arr_FV['BAT']" />
                            </div>
                        </div>
                        <div class='searchBtnCol'>
                            <CButton v-shortkey="['enter']" @shortkey="newSearch()" class='searchBtn' ref="search" size="sm" block color="success" @click="newSearch()">
                                <span class='searchIcon cil-search'></span>
                                <span>{{this.getLanguage["BTN"]["SR"]}}</span>
                            </CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>

            <div class='table-wrapper'>
                <header class="table-header">
                    <div class="d-md-flex align-items-center">
                        <strong>{{ this.getLanguage["SACH"]["CH"] }}</strong>
                        <div class="ml-0 ml-md-2">
                            <span v-if="this.getUserInfo.AT == 4 && this.getUserInfo.IOL" style="white-space: pre;">
                                <span style=" border-right: solid 1px; padding-right: 5px;">(<i class="fa-solid fa-house theme-outlet mr-1"></i> <strong>{{getLanguage["SUB"]["OLT"]}}</strong></span>
                                <span><span class="subagent-icon mr-1" style="background: #0c1033 !important;padding-top: 0; ">0</span> <strong>{{getLanguage["AFF"]["T"]}}</strong>)</span>
                            </span>
                            <span v-else-if="this.getUserInfo.AT == 4 && !this.getUserInfo.IOL" style="white-space: pre;">
                                <span style=" border-right: solid 1px; padding-right: 5px;">(<i class="fas fa-users theme-subagent mr-1"></i> <strong>{{getLanguageOEMI(this.getUserInfo.OEMI,"SUB","AG")}}</strong></span>
                                <span><span class="subagent-icon mr-1" style="background: #0c1033 !important;padding-top: 0; ">0</span> <strong>{{getLanguage["AFF"]["T"]}}</strong>)</span>
                            </span>
                            <span v-else>
                                <span style=" border-right: solid 1px; padding-right: 5px;">(<i class="fas fa-users theme-subagent mr-1"></i> <strong>{{getLanguageOEMI(this.getUserInfo.OEMI,"SUB","AG")}}</strong></span>
                                <span style=" border-right: solid 1px; padding-right: 5px;"><i class="fa-solid fa-house theme-outlet mr-1"></i> <strong>{{getLanguage["SUB"]["OLT"]}}</strong></span>
                                <span><span class="subagent-icon mr-1" style="background: #0c1033 !important;padding-top: 0; ">0</span> <strong>{{getLanguage["AFF"]["T"]}}</strong>)</span>
                            </span>
                        </div>
                    </div>

                    <div class="pageBtn">
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>

                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>{{this.getLanguage["GL"]["NO"]}}</th>
                                <th>{{this.getLanguage['AG']['G']}}<i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["SACH"]["CB"] }}</th>
                                <th>{{ this.getLanguage["AG"]["BAT"] }}<i @click="setSortTable('BT')" :class="setSortLogo('BT')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["SACH"]["TG"] }}<i @click="setSortTable('TGN')" :class="setSortLogo('TGN')" class="sortlogo"></i></th>
                                <th class="tableCtnRight">{{ this.getLanguage["AG"]["RSSB"] }} / {{ this.getLanguage["AG"]["BTUA"] }}<i @click="setSortTable('BU')" :class="setSortLogo('BU')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["GL"]["DT"] }}<i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo"></i></th>
                                <th>{{ getLanguage["CR"]["CB"] }}<i @click="setSortTable('CB')" :class="setSortLogo('CB')" class="sortlogo"></i></th>
                                <th>{{ getLanguage["AG"]["CIP"] }}<i @click="setSortTable('CIP')" :class="setSortLogo('CIP')" class="sortlogo"></i></th>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>{{this.getLanguage["GL"]["NO"]}}</th>
                                <th>{{this.getLanguage['AG']['G']}}<i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["SACH"]["CB"] }}</th>
                                <th>{{ this.getLanguage["AG"]["BAT"] }}<i @click="setSortTable('BT')" :class="setSortLogo('BT')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["SACH"]["TG"] }}<i @click="setSortTable('TGN')" :class="setSortLogo('TGN')" class="sortlogo"></i></th>
                                <th class="tableCtnRight">{{ this.getLanguage["AG"]["RSSB"] }} / {{ this.getLanguage["AG"]["BTUA"] }}<i @click="setSortTable('BU')" :class="setSortLogo('BU')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["GL"]["DT"] }}<i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo"></i></th>
                                <th>{{ getLanguage["CR"]["CB"] }}<i @click="setSortTable('CB')" :class="setSortLogo('CB')" class="sortlogo"></i></th>
                                <th>{{ getLanguage["AG"]["CIP"] }}<i @click="setSortTable('CIP')" :class="setSortLogo('CIP')" class="sortlogo"></i></th>
                            </tr>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if=" arr_Balance.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-for="(data,index) in arr_Balance">
                            <td>{{ CountItem(index+1) }}</td>
                            <td>
                                <div class="d-flex align-items-center" style="gap:10px;">
                                    <span>
                                        <i class=" " :class="[data.IOL?'fa-solid fa-house theme-outlet ml-2':'fas fa-users theme-subagent ml-2']"></i>
                                        <span v-if="data.AL!=0" :class="['subagent-icon', data.IOL?'outlet':'nonoutlet']">{{ data.AL.toString() }}</span>
                                    </span>
                                    <div>
                                        <span class="grid-line">{{ data.GN }}</span>
                                        <span class="grid-line">({{ data.PC }})</span>
                                    </div>
                                    <div class="custom-tooltip" v-if="data.IGGE">
                                        <img src="https://media.afb.gg/BackOfficeSiteIco/ggearn-ico2.png" class="nwithdraw-icon" />
                                        <span class="custom-tooltiptext" style="background-color: black; color: white; position: absolute;">GGEarn</span>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <span class="grid-line">{{ formatNumber(data.SBB, 2, data.CS) }} -> <span>{{ formatNumber(data.SBB + data.BU, 2, data.CS) }}</span></span>
                            </td>
                            <td>{{ renderBalanceType(data.BT) }}</td>
                            <td>
                                <span class="grid-line" v-if="data.BT!=2">-</span>
                                <span class="grid-line" v-if="data.BT==2 && data.TGN">{{ data.TGN }}</span>
                                <span class="grid-line" v-if="data.BT==2 && data.TPC">({{ data.TPC }})</span>
                            </td>
                            <td :class="data.BU >= 0? 'positive-number tableCtnRight': 'negative-number tableCtnRight'">{{ formatNumber(data.BU, 2, data.CS) }}</td>
                            <td>{{ formatDateTime(data.CTS, "YYYY-MM-DDTHH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                            <td>{{ data.CB }}</td>
                            <td>{{ data.CIP }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { constSubAdjustmentType, constAccessType } from '@/modules/Constant.js';
    import DateRangePicker from 'vue2-daterange-picker';
    import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
    import Treeselect from '@riophae/vue-treeselect';
    import { customtreeselect } from '@/views/CustomControl/index.js';
    import '@riophae/vue-treeselect/dist/vue-treeselect.css';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import { mapGetters, mapActions } from 'vuex';
    import genericHelper from "@/modules/GenericHelper.js";
    import { required, decimal, minValue } from 'vuelidate/lib/validators';
    import moment from "moment";
    import Vue from 'vue'
    import $ from 'jquery'
    //Vue.use(require('vue-shortkey'))

    export default {
        mixins: [genericHelper],
        components: {
            DateRangePicker,
            Treeselect,
            customtreeselect,
            Loading,
        },
        data() {
            return {
                int_RC: 100, //Row Count
                int_Total: 0,
                int_Page: 1,
                int_IC: 1, // Item Count
                int_TP: 1, //Total Page
                str_tableSortBy: "CTS", //(sort the table col name)
                bool_isSort: false, // Table Ascending Descending
                arr_FV: {
                    "DR": {
                        startDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
                        endDate: this.getTodayEndDate()
                    },
                    "AGI": null,
                    "BAT": null
                }, //Filter Value
                bool_isAMV: false, // Add Modal Visible
                bool_isBT: false,
                bool_fullLoading: false,
                bool_showSearchBar: true,
                bool_isOutlet: false,
                arr_Balance: [],
                obj_Balance: {
                    "I": 0,
                    "RS": 2,
                    "PAGI": "",
                    "PAGIT": null,
                    "AGI": "",
                    "AGIT": null,
                    "BT": 0,
                    "BU": 0.00,
                    "CB": null
                },
                obj_Bonus: {
                    "I": 0,
                    "RS": 2,
                    "PAGI": "",
                    "PAGIT": null,
                    "AGI": "",
                    "AGIT": null,
                    "BT": 0,
                    "BONT": 0,
                    "BU": 0.00,
                    "PMB": 0,
                    "CMB": 0,
                    "BA": 0,
                    "AA": 0     //AdjustAmount
                },
                bool_balanceCV: false,
                dd_balancetype: [],
                dd_agentgroup: [],
                dd_agentgroup2: [],
                ddSubBrandList: [],
                ddDefaultSubBrand: [],
                ddDefaultSubBrandSearch: null,
                dd_adjustmenttype: [],
                str_availablebalance: '',
                dec_availablebalance: 0,
                str_currencysymbol: "",
                str_decimalSeparator: "",
                str_thousandSeparator: "",
                str_invalidAmountMsg: "",
                str_sagcreditbalance: '',
                dec_sagcreditbalance: 0,
                bool_cacheOptionValue: false,
                selectedMinBonus: 0,
                selectedMaxBonus: 0,

                subbrandkey: 0,
                constAccessType: constAccessType,
            }
        },
        validations: {
            obj_Balance: {
                AGIT: { required },
                BU: { required, decimal },
            },
            obj_Bonus: {
                AGIT: { required },
                AA: { decimal },
            },
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('CurrencyInfo', ['getThousandCurrency']),
            ...mapGetters('UserInfo', ['checkModuleAccess', 'getUserInfo']),
        },
        watch: {
            bool_isAMV() {
                if (!this.bool_isAMV && this.bool_balanceCV) {
                    this.showSuccessMessage(this.utilGetErrorLanguage("ERR.SS"), this.utilGetErrorLanguage("GL.AS"));
                    this.bool_balanceCV = false;
                }
            },
            bool_isBT() {
                if (!this.bool_isBT && this.bool_balanceCV) {
                    this.bool_balanceCV = false;
                }
            }
        },
        methods: {
            ...mapActions('CurrencyInfo', ['setThousandCurrency']),
            DateTimeChange(type, event) {
                if (type == "SD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.arr_FV.DR.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.arr_FV.DR.startDate = "";
                    }
                }
                if (type == "ED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.arr_FV.DR.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.arr_FV.DR.endDate = "";
                    }
                }
            },
            CurrencyChange(value) {
                this.setThousandCurrency(this.CheckIsThousandCurrency(value, this), this);
            },
            renderBalanceType(balancetype) {
                var balanceTypeDisplay = "";
                switch (balancetype) {
                    case 0:
                        balanceTypeDisplay = this.getLanguage["AG"]["MSB"];
                        break;
                    case 1:
                        balanceTypeDisplay = this.getLanguage["AG"]["TUSB"];
                        break;
                    case 2:
                        balanceTypeDisplay = this.getLanguage["AG"]["DLSB"];
                        break;
                    case 3:
                        balanceTypeDisplay = this.getLanguage["AG"]["RTSB"];
                        break;
                    case 4:
                        balanceTypeDisplay = this.getLanguage["AG"]["DPSB"];
                        break;
                    case 5:
                        balanceTypeDisplay = this.getLanguage["AG"]["WDSB"];
                        break;
                    case 6:
                        balanceTypeDisplay = this.getLanguage["AG"]["PMSB"];
                        break;
                    case 7:
                        balanceTypeDisplay = this.getLanguage["AG"]["POSB"];
                        break;
                    case 99:
                        balanceTypeDisplay = this.getLanguage["AG"]["RSSB"];
                        break;
                }

                return balanceTypeDisplay;
            },
            ValidationSystemBalanceErrMsg(value, langKey = "") {
                if (this.bool_balanceCV) {
                    var parent = "";
                    var key1 = "AG";

                    if (value.indexOf(".") >= 0) {
                        var tempKey = value.split('.');
                        parent = tempKey[0];
                        value = tempKey[1];
                    }

                    if (langKey == "") {
                        langKey = value;
                    }
                    else if (langKey.indexOf(".") >= 0) {
                        var tempKey = langKey.split('.');
                        key1 = tempKey[0];
                        langKey = tempKey[1];
                    }

                    var validateObj = parent == "" ? this.$v[value] : this.$v[parent][value];

                    if (validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage[key1][langKey]);
                    }
                    else if (validateObj.minValue != undefined && !validateObj.minValue) {
                        return String.format(this.utilGetErrorLanguage('1005'), this.getLanguage[key1][langKey]);
                    }
                    else if (validateObj.decimal != undefined && !validateObj.decimal) {
                        return String.format(this.utilGetErrorLanguage('1007'), this.getLanguage[key1][langKey]);
                    }
                    else if (validateObj.between != undefined && !validateObj.between) {
                        return String.format(this.utilGetErrorLanguage('SAPS.ERRBTW'), this.getLanguage[key1][langKey], this.selectedMinBonus, this.selectedMaxBonus);
                    }

                    if (this.str_invalidAmountMsg != "" && (value == "BU" || value == "AA")) {
                        return this.str_invalidAmountMsg;
                    }
                }
            },
            closeAdd() {
                this.bool_isAMV = !this.bool_isAMV;
                this.bool_balanceCV = false;
            },
            closeAdd1() {
                this.bool_isBT = !this.bool_isBT;
                this.bool_balanceCV = false;
            },
            ctrPage(newPage,inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getSystemBalanceList();
            },
            newSearch() {
                if (!this.bool_isAMV) {
                    this.$refs.search.focus();
                    this.int_Page = 1;
                    this.int_IC = 1;
                    this.getSystemBalanceList();
                }
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            setSortTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isTAD}
                this.getSystemBalanceList();
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            getDropdownList(loadList) {
                var that = this;

                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s) {
                            var cloneParentGroup = that.deepClone(d.dropdownlist);
                            var firstAGI = "";

                            //// list filter only push in child group, do not include own group
                            if (cloneParentGroup != null && cloneParentGroup.length > 0) {
                                that.dd_agentgroup = [];
                                for (var i = 0; i < cloneParentGroup.length; i++) {
                                    //if (firstAGI == "")
                                    //    firstAGI = cloneParentGroup[i].id;
                                    that.dd_agentgroup.push(cloneParentGroup[i]);
                                }

                                that.dd_agentgroup.forEach(that.disableAgentGroupParent);
                            }

                            that.dd_agentgroup2 = d.dropdownlist;

                            if (that.dd_agentgroup2.length > 0) {
                                that.dd_agentgroup2.forEach(that.disableAgentGroupParent);
                            }

                            //var agiResult = that.recursiveSeach(that.dd_agentgroup, that.arr_FV.AGI);

                            //if (!agiResult)
                            //    that.arr_FV.AGI = firstAGI;

                            if (loadList) {
                                that.getSystemBalanceList();
                            }
                        }
                    });
            },
            recursiveSeach(obj, searchVal) {
                if (obj != null && obj.length > 0) {
                    for (var i = 0; i < obj.length; i++) {
                        if (obj[i].id == searchVal)
                            return true;

                        if (obj[i].children != null && obj[i].children.length > 0) {
                            var result = this.recursiveSeach(obj[i].children, searchVal);

                            if (result) return true;
                        }
                    }
                }

                return false;
            },
            getSystemBalanceList() {
                this.bool_fullLoading = true;

                var that = this;
                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);

                if (this.arr_FV) {
                    if (path) {
                        path += "&";
                    }
                    if (this.arr_FV["SAGAGI"]) {
                        path += ("&f.ATAGI=" + this.arr_FV["SAGAGI"]);
                    }
                    if (this.arr_FV['BAT'] != null) {
                        path += (
                            "&f.BAT=" + this.arr_FV["BAT"]);

                    }
                    if (this.arr_FV.DR.startDate != "") {
                        var cts_from = this.parseDateToJsonString(this.arr_FV.DR.startDate);
                        path += "&f.CTS_from=" + cts_from;
                    }
                    if (this.arr_FV.DR.endDate != "") {
                        var cts_to = this.parseDateToJsonString(this.arr_FV.DR.endDate);
                        path += "&f.CTS_to=" + cts_to;
                    }
                }

                this.getDataApi(`/api/ag/lscbh?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.int_TP = Math.max(d.D.TotalPages, 1);
                            that.int_Total = d.D.TotalItems;
                            that.arr_Balance = d.D.Items;
                            that.resizeTableHead();
                        }
                    });
            },
            adjustSystemBalance(balancetype) {
                var pagi = 0, agi = 0, agit = null;
                this.bool_balanceCV = false;
                this.bool_cacheOptionValue = false;

                if (this.arr_FV.AGI != null && this.arr_FV.AGI.length > 0) {
                    var agi = this.arr_FV.AGI.split("-");
                    if (agi.length == 2) {
                        pagi = agi[1];
                    }
                    else {
                        pagi = agi[0];
                    }
                }

                if (this.arr_FV.SAGAGI && this.arr_FV.SAGAGI != this.getUserInfo.AGI) {
                    agi = this.arr_FV.SAGAGI;
                    agit = this.arr_FV.SAGAGI;
                }

                this.obj_Balance = {
                    "I": 0,
                    "RS": 2,
                    "PAGI": pagi,
                    "PGIT": this.arr_FV.AGI,
                    "AGI": agi,
                    "AGIT": agit,
                    "BT": balancetype,
                    "BU": null,
                    "CB": ''
                };

                if (this.dd_agentgroup2.length > 0) {
                    this.dd_agentgroup2.forEach(this.disableAgentGroupParent);
                }

                if (agi && agi > 0) {
                    this.AgentGroupChange(agi);

                    if (this.ddDefaultSubBrandSearch && this.ddDefaultSubBrandSearch.length > 0) {
                        this.ddDefaultSubBrand = this.ddDefaultSubBrandSearch;
                    }
                    else {
                        this.ddDefaultSubBrand = this.ddSubBrandList;
                    }
                }

                this.bool_isAMV = true;

            },
            adjustSystemBonus(balancetype) {
                var pagi = 0, agi = 0, agit = null;
                this.bool_balanceCV = false;
                this.bool_cacheOptionValue = false;

                if (this.arr_FV.AGI != null && this.arr_FV.AGI.length > 0) {
                    var agi = this.arr_FV.AGI.split("-");
                    if (agi.length == 2) {
                        pagi = agi[1];
                    }
                    else {
                        pagi = agi[0];
                    }
                }

                if (this.arr_FV.SAGAGI && this.arr_FV.SAGAGI != this.getUserInfo.AGI) {
                    agi = this.arr_FV.SAGAGI;
                    agit = this.arr_FV.SAGAGI;
                }

                this.obj_Bonus = {
                    "I": 0,
                    "RS": 2,
                    "PAGI": pagi,
                    "PGIT": this.arr_FV.AGI,
                    "AGI": agi,
                    "AGIT": agit,
                    "BT": balancetype,
                    "BONT": 0,
                    "BU": 0,
                    "PMB": 0,
                    "CMB": 0,
                    "BA": 0,
                };

                if (this.dd_agentgroup2.length > 0) {
                    this.dd_agentgroup2.forEach(this.disableAgentGroupParent);
                }

                if (agi && agi > 0) {
                    this.AgentGroupChange(agi);

                    if (this.ddDefaultSubBrandSearch && this.ddDefaultSubBrandSearch.length > 0) {
                        this.ddDefaultSubBrand = this.ddDefaultSubBrandSearch;
                    }
                    else {
                        this.ddDefaultSubBrand = this.ddSubBrandList;
                    }
                }

                this.bool_isBT = true;

            },
            AvailableBalanceAmount() {
                return '-' + this.str_sagcreditbalance + '  —  ' + this.str_availablebalance;
            },
            AgentGroupChange(value) {
                console.log(value)
                this.bool_fullLoading = false;
                var that = this;
                var agi = 0;
                this.obj_Bonus.BU = 0;

                this.ddDefaultSubBrand = null;
                that.obj_Balance.CB = '';
                if (value != "" && value != undefined) {
                    var temp = value.split("-");
                    if (temp.length > 1 && temp[1] > 0) {
                        agi = temp[1];
                    }
                    else if (temp[0] > 0) {
                        agi = temp[0];
                    }
                }

                if (agi > 0) {
                    this.bool_fullLoading = true;
                    this.getDataApi(`/api/ag/gb-sub/${agi}`,
                        function (d, s) {
                            that.bool_fullLoading = false;

                            if (s) {
                                that.bool_isOutlet = d.D.IOL;
                                that.dec_availablebalance = d.D.TB - d.D.BL;
                                that.str_availablebalance = that.formatNumber(that.dec_availablebalance, 2, d.D.CS);

                                that.dec_sagcreditbalance = d.D.CDBL;
                                that.str_sagcreditbalance = that.formatNumber(that.dec_sagcreditbalance, 2, d.D.CS);
                                that.obj_Balance.CB = that.str_sagcreditbalance;

                                that.str_currencysymbol = d.D.CS;
                                that.str_thousandSeparator = d.D.TS;
                                that.str_decimalSeparator = d.D.DS;
                                that.CurrencyChange(d.D.CS);
                            }

                            //Get bonus used info
                            if (that.bool_isBT) {
                                that.getDataApi(`/api/sag/gbu/${agi}`,
                                    function (d, s) {
                                        if (s) {
                                            that.obj_Bonus.PMB = d.D.PMB;
                                            that.obj_Bonus.CMB = d.D.CMB;
                                            that.obj_Bonus.BA = d.D.BA;

                                            that.obj_Bonus.BU = that.obj_Bonus.PMB + that.obj_Bonus.CMB - that.obj_Bonus.BA;
                                            that.selectedMaxBonus = that.obj_Bonus.BU;
                                            that.obj_Bonus.BU = that.formatNumber(that.obj_Bonus.BU, 2, that.str_currencysymbol);
                                        }
                                    });
                            }
                        });
                }
            },
            disableAgentGroupParent(item, index) {
                var agi = item.id.split("-");
                if (agi[0] != "3") {
                    item.isDisabled = true;
                }

                if (item.children && item.children.length > 0) {
                    item.children.forEach(this.disableAgentGroupParent);
                }
            },
            updateBalance() {
                if (this.obj_Balance.AGIT != null && this.obj_Balance.AGIT.length > 0) {
                    var agi = this.obj_Balance.AGIT.split("-");
                    if (agi.length == 2) {
                        this.obj_Balance.AGI = agi[1];
                    }
                    else {
                        this.obj_Balance.AGI = agi[0];
                    }
                }

                if (this.obj_Balance.BU == null) {
                    this.obj_Balance.BU = 0;
                }

                //// check the require field
                this.str_invalidAmountMsg = '';
                this.bool_balanceCV = true;
                this.$v.obj_Balance.$touch();
                let isValid = true;

                if (!this.obj_Balance.BU || this.obj_Balance.BU == 0 || this.obj_Balance.BU > this.dec_availablebalance || this.obj_Balance.BU < (this.dec_sagcreditbalance * -1)) {
                    this.str_invalidAmountMsg = this.utilGetErrorLanguage('10031');
                    isValid = false;
                }

                if (!this.$v.obj_Balance.$error && isValid) {
                    this.bool_fullLoading = true;
                    var that = this;

                    this.postDataApi(`/api/ag/sagbh`, this.obj_Balance,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            if (s) {
                                that.bool_isAMV = false;

                                that.getSystemBalanceList();
                            }
                        });
                }
            },
            updateBonus() {
                var adjustAmt = 0;

                if (this.obj_Bonus.AGIT != null && this.obj_Bonus.AGIT.length > 0) {
                    var agi = this.obj_Bonus.AGIT.split("-");
                    if (agi.length == 2) {
                        this.obj_Bonus.AGI = agi[1];
                    }
                    else {
                        this.obj_Bonus.AGI = agi[0];
                    }
                }

                if (this.obj_Bonus.BONT == 1)
                    adjustAmt = this.obj_Bonus.AA * -1;
                else
                    adjustAmt = this.obj_Bonus.AA;

                if (this.obj_Bonus.BU == null) {
                    this.obj_Bonus.BU = 0;
                }

                this.str_invalidAmountMsg = '';
                this.bool_balanceCV = true;
                this.$v.obj_Bonus.$touch();
                let isValid = true;

                if (!this.obj_Bonus.AA < 0 || !this.obj_Bonus.AA ||
                    (this.obj_Bonus.BONT == 0 && (this.obj_Bonus.AA < this.selectedMinBonus || this.obj_Bonus.AA > this.selectedMaxBonus))) {
                    this.str_invalidAmountMsg = String.format(this.utilGetErrorLanguage('1005'), this.getLanguage["PM"]["PA"]);
                    isValid = false;
                }

                if (!this.$v.obj_Bonus.$error && isValid) {

                    this.$fire({
                        title: this.getLanguage["MTA"]["CA"],
                        width: '30em',
                        showCancelButton: true,
                        confirmButtonText: this.getLanguage["GL"]["YES"],
                        cancelButtonText: this.getLanguage["CNO"]["NO"],
                        reverseButtons: true,
                        customClass: {
                            title: 'afb-alert-title',
                            content: 'afb-alert-content',
                            actions: 'afb-alert-action'
                        }
                    }).then((result) => {
                        if (result.value == true) {
                            this.bool_fullLoading = true;
                            var that = this;
                            var dt = {
                                AGI: this.obj_Bonus.AGI,
                                AA: adjustAmt,
                            };

                            this.postDataApi(`/api/sag/sagbu`, dt,
                                function (d, s) {
                                    that.bool_fullLoading = false;
                                    if (s) {
                                        that.bool_isBT = false;
                                        that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                        that.getSystemBalanceList();
                                    }
                                });
                        }
                    });
                }
            },

            clearDateRangeFilter() {
                this.arr_FV.DR = {
                    startDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
                    endDate: this.getTodayEndDate()
                };
            },
            loadSubBrandOptions({ action, searchQuery, callback }) {
                var that = this;
                var parentAGI = 0;

                if (this.obj_Balance.PAGI && this.bool_isAMV) {
                    parentAGI = this.obj_Balance.PAGI;
                } else if (this.arr_FV['AGI'] && !this.bool_isAMV) {
                    parentAGI = this.arr_FV['AGI'].split("-")[1];
                } else {
                    callback(this.getLanguage['MEM']['PSAA']);
                }

                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    this.ddSubBrandList = [];
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${parentAGI}/0`,
                        function (d, s) {
                            var ddList = [];
                            if (s && d && d.dropdownlist) {
                                that.ddDefaultSubBrand = null;
                                that.bool_cacheOptionValue = true;

                                for (var i = 0; i < d.dropdownlist.length; i++) {
                                    if (d.dropdownlist[i].id != that.getUserInfo.AGI) {
                                        ddList.push(d.dropdownlist[i]);
                                    }
                                }
                            }

                            callback(null, ddList);
                        });
                }
            },
            loadSubBrandOptionsSearch({ action, searchQuery, callback }) {
                var that = this;
                var parentAGI = 0;

                if (this.obj_Balance.PAGI && this.bool_isAMV) {
                    parentAGI = this.obj_Balance.PAGI;
                } else if (this.arr_FV['AGI'] && !this.bool_isAMV) {
                    parentAGI = this.arr_FV['AGI'].split("-")[1];
                } else {
                    callback(this.getLanguage['MEM']['PSAA']);
                }

                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    this.ddSubBrandList = [];
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${parentAGI}/1`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddDefaultSubBrandSearch = null;
                                that.ddSubBrandList = d.dropdownlist;
                                that.bool_cacheOptionValue = true;
                            }
                            else {
                                that.ddSubBrandList = [];
                            }

                            callback(null, that.ddSubBrandList);
                        });
                }
            },
            ParentGroupChange(value) {
                this.bool_fullLoading = false;
                var agi = 0;
                this.bool_cacheOptionValue = false;

                if (value != "" && value != undefined) {
                    var agi = value.split("-")[1];
                    this.obj_Balance.PAGI = agi;
                } else {
                    this.obj_Balance.PAGI = 0;
                }

                this.obj_Balance.AGI = null;
                this.obj_Balance.AGIT = null;
                this.ddDefaultSubBrand = null;
            },
            SearchParentGroupChange(value) {
                this.arr_FV.SAGAGI = null;
                this.ddDefaultSubBrandSearch = null;
            },
            SearchSubGroupChange(value) {
                var that = this;
                this.bool_isOutlet = false;
                if (value) {
                    this.bool_fullLoading = true;
                    this.getDataApi(`/api/sag/g/${value}`,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            if (s && d && d.D) {
                                that.bool_isOutlet = d.D.IOL;
                            }
                        });
                }
            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);
                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(1) th');

                if (!headerCells.length) return;

                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                    if (!bodyCells.length) return;

                    // Reset all widths
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                    // Apply new widths
                    bodyCells.forEach((cell, index) => {
                        if (!headerCells[index]) return;  // Add a safety check to avoid undefined errors

                        const headerWidth = headerCells[index].getBoundingClientRect().width;
                        const bodyWidth = cell.getBoundingClientRect().width;
                        const width = `${Math.max(bodyWidth, headerWidth)}px`;

                        headerCells[index].style.width = width;
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('SUB', 'AGS', type);
            },
        },
        created() {
            var that = this;
            var temp = [];
            this.$parent.showSubMenu = 'AGS';
            this.$parent.showActiveMenu = 'AGS.SUB';

            var parameters = this.$route.query;

            if (this.getUserInfo.AT == 4) {
                this.arr_FV.AGI = '3-' + this.getUserInfo.AAGI;
                this.arr_FV['AGI'] = '3-' + this.getUserInfo.AAGI;
            }

            if (parameters.iol !== undefined) {
                this.bool_isOutlet = parameters.iol == 1 ? true : false;
            }

            if (parameters.agi !== undefined) {
                temp = parameters.agi.split("-");
            }

            if (parameters.agn !== undefined) {
                if (this.getUserInfo.AT != 4) {
                    this.arr_FV.AGI = parameters.pgit;
                }
                if (temp.length > 1) {
                    this.ddDefaultSubBrandSearch = [{ "id": temp[1], "label": parameters.agn }];
                    this.arr_FV.SAGAGI = temp[1];
                    this.getDropdownList(true);
                }
            }
            else {
                const options = {
                    searchQuery: "[0]",
                    callback: (nothing, ddList) => {
                        that.ddDefaultSubBrandSearch = ddList;
                        that.arr_FV['SAGAGI'] = ddList[0].id;
                        that.subbrandkey = that.subbrandkey == 1 ? 0 : 1;
                    }
                };
                this.loadSubBrandOptionsSearch(options);

                this.getDropdownList(false);
                this.getSystemBalanceList();
            }
            this.setThousandCurrency(false);
            this.dd_adjustmenttype = constSubAdjustmentType;
            this.isOUTMOB = (localStorage.getItem('isOutletMobile') == 'True') ? true : false;
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/SideMenu/AgentSetting/SubAgentCreditHistory.vue